import { Key, storage } from '@soluto-private/mx-context';

import isPartnerLocalizable from './isPartnerLocalizable';
import overrideSdkLanguageSettings from './overrideSdkLanguageSettings';

const updateLanguageFromContext = async (): Promise<void> => {
    const partner = storage.get(Key.Client);

    if (isPartnerLocalizable(partner)) {
        const locale = storage.get(Key.Language);
        await overrideSdkLanguageSettings(locale);
    }
};

export default updateLanguageFromContext;
